module.exports = __webpack_public_path__ + "static/media/artistic.037e36b7.jpg";